<template>
  <v-expansion-panel v-if="!hideDetail && shouldShowPanel" :disabled="!amountDetail[0]">
    <v-expansion-panel-header
      justify-space-between
      class="color--nice-black"
      v-slot:default="{ open }"
    >
      <v-flex>
        {{ title }}
        <v-icon v-show="amountDetail[0]" class="arrow-down" :class="{ 'rotate-arrow': open }">
          mdi-menu-up
        </v-icon>
      </v-flex>
      <v-flex class="text-right" v-if="!(hideFee && title === '기타')">
        {{ $filters.commaFormat(sumByPropertyName(amountDetail, 'amount')) }} 원
      </v-flex>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="elevation-0" v-if="!(hideFee && title==='수수료')">
      <div v-for="(detail, index) in filteredAmountDetail" :key="title + index">
        <template v-if="!detail.details">
          <v-layout justify-space-between class="color--nice-grey subtitle">
            <v-flex>
              {{ detail.name }}
            </v-flex>
            <v-flex class="text-right">{{ $filters.commaFormat(detail.amount) }} 원</v-flex>
          </v-layout>
        </template>
        <template v-else>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header v-slot:default="{ open: open1 }">
                <v-layout
                  justify-space-between
                  class="color--nice-grey subtitle mb-0"
                  style="height: 19.5px"
                >
                  <v-flex>
                    {{ detail.name }}
                    <v-icon
                      v-show="detail.details"
                      class="arrow-down"
                      :class="{ 'rotate-arrow': open1 }"
                    >
                      mdi-menu-up
                    </v-icon>
                  </v-flex>
                  <v-flex class="text-right">{{ $filters.commaFormat(detail.amount) }} 원</v-flex>
                </v-layout>
              </v-expansion-panel-header>
              <v-expansion-panel-content :eager="true">
                <div v-if="detail.details" class="ml-3 error--text text-left font-size--12">
                  <div v-for="(v, k) in detail.details" :key="k">
                    <v-layout justify-space-between>
                      <span>└{{ k }}({{ $filters.commaFormat(v.count) }}건) </span>
                      <span>{{ $filters.commaFormat(v.totalAmount) }}원</span>
                    </v-layout>

                    <!-- <v-layout justify-space-between class="pl-3">
                    <span>└11:19 94401799*****22</span>
                    <span>111원</span>
                  </v-layout> -->
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { sumByPropertyName } from '@/util/mathUtil'

export default {
  props: ['title', 'amountDetail', 'hideFee', 'hideDetail'],
  methods: {
    sumByPropertyName,
  },
  computed: {
    filteredAmountDetail() {
      
      let filtered = this.amountDetail;
      if (this.hideFee) {
        filtered = filtered.filter(detail => !["선정산 이자", "운영 수수료", "수수료"].includes(detail.name));
      }
      
      if (this.title === '기타') {
        filtered = filtered.filter(detail => detail.amount !== 0);
      }
      
      console.log('!!!!!!!! filtered', filtered)
      return filtered;
    },
    shouldShowPanel() {
      if (this.title === '기타') {
        const sum = this.sumByPropertyName(this.filteredAmountDetail, 'amount');
        return sum !== 0;
      }
      return true;
    }
  },
}
</script>

<style lang="scss" scoped>
.section-wrapper {
  p {
    font-size: 12px;
    margin: 0;
  }
}

:deep .v-expansion-panel {
  &-header {
    margin-bottom: 10px;
    font-weight: bold;
    padding: 0;
    min-height: unset;

    &__icon {
      display: none;
    }

    .v-icon {
      &.arrow-down {
        transition: transform 0.5s;
      }

      &.rotate-arrow {
        transform: rotate(180deg);
      }
    }
  }

  &-content {
    &__wrap {
      padding: 0;
    }
  }
}

::v-deep .v-expansion-panel::before {
  box-shadow: none !important;
}
</style>